import request from '../../util/SuperagentUtils';
import type {PartnerSubscription} from '../../types/PartnerSubscription';

export const requestCreateSubscription = (subscription: PartnerSubscription) => {
    return request.post(`/api/partner-subscription`)
        .send(subscription);
}

export const requestGetSubscription = (accountId: string) => {
    return request.get(`/api/partner-subscription/${accountId}`)
}

export const requestDeletePartnerSubscription = (partnerSubscriptionId: string) => {
    return request.delete(`/api/partner-subscription/${partnerSubscriptionId}`)
}

export const requestUpdatePartnerSubscription = (partnerSubscriptionId: string, partnerSubscription: PartnerSubscription) => {
    return request.patch(`/api/partner-subscription/${partnerSubscriptionId}`)
      .send(partnerSubscription);
}

export const getTransactionsByPartnerSubscriptionId = (partnerSubscriptionId: string) => {
    return request.get(`/api/partner-subscription-transaction?partnerSubscriptionId=${partnerSubscriptionId}`);
}